import React from "react"

export const NoticepagePaywallSticker = ({ show_video }) => {
  return (
    <div
      key="blurred_text_paywall_notice_message"
      style={{
        border: "2px solid #034055",
      }}
      className="mx-4 mb-4 box has-text-mitternachtsblau has-text-centered p-6"
    >
      <p className="title is-3 is-size-5-mobile has-text-mitternachtsblau mb-6">
        Mehr Inhalt. Mehr Aufträge. Mehr Umsatz.
      </p>

      <p
        className="has-text-mitternachtsblau has-text-centered mb-6 mx-auto"
        style={{ maxWidth: 496 }}
      >
        Sie möchten weiterlesen? Profitieren Sie von unserer
        Ausschreibungsdatenbank mit einem{" "}
        <span className="is-underlined">kostenfreien</span> Testaccount.
      </p>

      <div className="buttons is-centered mt-6">
        <a className="button is-tertiary" href=" #" onClick={show_video}>
          Video ansehen
        </a>
        <a
          className="button is-mitternachtsblau"
          href={`${process.env.GATSBY_AD_SOFTWARE_PRODUCT_REGISTER_ADDRESS}${process.env.GATSBY_AD_SOFTWARE_PRODUCT_FREE_TEST_ID}`}
        >
          Kostenfrei weiterlesen
        </a>
      </div>
    </div>
  )
}
